import { Box, styled as muiStyled } from '@mui/material';

export const BrightnessSliderTitleAndResetIcon = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
